import { Box, Skeleton, Stack, useTheme } from '@mui/material';

export const DetailsLoading = () => {
	const theme = useTheme();
	const sk = { bgcolor: theme.palette.action.hover, borderRadius: theme.spacing(0.5) };
	return (
		<Box sx={{ width: '100%', py: 0.5 }}>
			<Stack spacing={2}>
				<Stack direction="row" spacing={1}>
					<Skeleton variant="rounded" height={24} width={100} sx={sk} />
					<Skeleton variant="rounded" height={24} width={100} sx={sk} />
				</Stack>
				<Skeleton variant="rounded" height={120} sx={sk} />
				<Skeleton variant="rounded" height={48} sx={sk} />
				<Skeleton variant="rounded" height={48} sx={sk} />
			</Stack>
		</Box>
	);
};
